import { Directive, ElementRef, Input, AfterViewInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appPCheckboxTabindex]'
})
export class PCheckboxTabindexDirective implements AfterViewInit {
  @Input('appPCheckboxTabindex') tabindex = '0';
  private focusListener: (() => void) | undefined;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngAfterViewInit() {
    // Find the native checkbox input inside p-checkbox
    const input: HTMLInputElement | null = this.el.nativeElement.querySelector('input[type="checkbox"]');
    if (input) {
      this.renderer.setAttribute(input, 'tabindex', this.tabindex);
    }
  }
}
